module.exports = __webpack_public_path__ + "img/party_lower_5.437bc9cc.jpg";